import { type ReactNode, useEffect, useMemo, useState } from 'react';

import {
  HeaderContext,
  type InstallationHeaderInfo,
  type ProjectHeaderInfo,
} from './HeaderContext';

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [project, setProject] = useState<ProjectHeaderInfo | null>(null);
  const [installation, setInstallation] = useState<InstallationHeaderInfo | null>(null);
  const [height, setHeight] = useState(44);
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.style.getPropertyValue('--app-header-height');
    root.style.setProperty('--app-header-height', `${height}px`);
    return () => {
      if (previous) root.style.setProperty('--app-header-height', previous);
      else root.style.removeProperty('--app-header-height');
    };
  }, [height]);
  const value = useMemo(
    () => ({ project, installation, height, setProject, setInstallation, setHeight }),
    [project, installation, height]
  );
  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
}
